import React from 'react';
import { Link } from 'react-router';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { matchesProperty, times } from 'lodash/util';
import { OverlayTrigger, Popover, Glyphicon } from 'react-bootstrap';
import find from 'lodash/find';
import filter from 'lodash/filter';
import { I18N } from '../../../../constants';
import { formatDate } from '../../../../shared/utils/date';
import { formatRun } from '../../../../shared/utils/run';
import { renderPaginationShowsTotal } from '../../../../shared/utils/table';
import SmallLoader from '../../../../components/SmallLoader';
import RFUSearch from "../components/RFUSearch";
import {
    Button,
    Form,
    FormControl,
    FormGroup,
    ControlLabel,
    Col,
    Row,
    Checkbox,
} from "react-bootstrap";

const abnormalityStyles = {
    RED: 'RED',
    ORANGE: 'ORANGE',
    YELLOW: 'YELLOW',
    GREEN: 'GREEN',
    GREY: 'GREY',
    WHITE: 'WHITE',
};

class RFUTable extends React.PureComponent {
    getIconColor = abnormalities => {
        const severities = filter(abnormalities, a => a.severity);

        if (find(severities, matchesProperty('severity', abnormalityStyles.RED)) !== undefined) {
            return 'red';
        }
        if (find(severities, matchesProperty('severity', abnormalityStyles.ORANGE)) !== undefined) {
            return 'orange';
        }
        if (find(severities, matchesProperty('severity', abnormalityStyles.YELLOW)) !== undefined) {
            return 'yellow';
        }
        if (find(severities, matchesProperty('severity', abnormalityStyles.GREEN)) !== undefined) {
            return 'green';
        }
        if (find(severities, matchesProperty('severity', abnormalityStyles.GREY)) !== undefined) {
            return 'grey';
        }

        return 'white';
    };

	

    manifestsFormatter = orderGroupIndex => (cell, row) => {
        let values = [];

        if (!!row.orderGroups[orderGroupIndex] && !!row.orderGroups[orderGroupIndex].manifests) {
            const orderGroup = row.orderGroups[orderGroupIndex];
            if (orderGroup.manifests.length > 0) {
                orderGroup.manifests.map(manifest => {
                    return values.push(this.manifestAbnormalitiesFormatter(manifest));
                });
            }
        }

        if(this.props.showManifestNumber==true){

            return (
                <div>
                    {React.Children.toArray(values).reduce((elements, child, i, array) => {
                        elements.push(child);
                        if (i < array.length - 1) {
                            elements.push(' | ');
                        }
                        return elements;
                    }, [])}
                </div>
            );

        }

        else
        return (
            <div id='element' className='element'>
                {React.Children.toArray(values).reduce((elements, child, i, array) => {
                    elements.push(child);
                    if (i < array.length - 1) {
                        elements.push(' | ');
                    }
                    return elements;
                }, [])}
            </div>
        );
    };

    manifestAbnormalitiesFormatter = manifest => {
        if (manifest.abnormalities === null || manifest.abnormalities.length === 0) {
            return <span>{manifest.manifestSequence}</span>;
        }

        const popoverTitle = (
            <Link to={`/manifests/${manifest.manifestId}`}>{`Manifest ${
                manifest.manifestNumber
            }`}</Link>
        );

        const popover = (
            <Popover id="rfu-abnormalities-popover-top" title={popoverTitle}>
                {manifest.abnormalities.map((abnormality, index) => (
                    <p className="popover-list-item" key={index}>
                        <Glyphicon
                            className={
                                abnormality.severity &&
                                abnormalityStyles[abnormality.severity].toLowerCase()
                            }
                            title="Type of abnormality"
                            glyph="alert"
                        />{' '}
                        {I18N.ABNORMALITIES[abnormality.abnormalityType]}
                        <br />
                        <Glyphicon
                            className={
                                abnormality.severity &&
                                abnormalityStyles[abnormality.severity].toLowerCase()
                            }
                            title="Location of the abnormality"
                            glyph="globe"
                        />{' '}
                        {abnormality.abnormalityLocation || 'N/A'}
                        <br />
                        <Link to={`/runs/${abnormality.abnormalityRunId}`}>
                            <Glyphicon
                                className={
                                    abnormality.severity &&
                                    abnormalityStyles[abnormality.severity].toLowerCase()
                                }
                                title="Run on which the abnormality occurred"
                                glyph="road"
                            />
                            {formatRun({
                                routeCode: abnormality.abnormalityRouteCode,
                                runDate: abnormality.abnormalityRunDate,
                                runSequence: abnormality.abnormalityRunSequence,
                            })}
                        </Link>
                    </p>
                ))}
            </Popover>
        );


        return (
            <div><OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popover}>
                <Glyphicon
                    glyph="alert"
                    className={`${this.getIconColor(manifest.abnormalities)} clickable`}
                />
            </OverlayTrigger>
			<br />
               {(this.props.showManifestNumber &&
                   manifest.manifestNumber.slice(-4))}
           </div>
        );
    };

    render() {
        const {
            manifestOrderGroups,
            maxOrderGroups,
            maxManifestsPerOrderGroup,
            isFetching,showManifestNumber,
        } = this.props;

        // Build manifest order group
        const maxNumberOfOrderGroups = maxOrderGroups;
        const columns = [
            {
                dataField: 'id',
                hidden: true,
            },
            {
                dataField: 'manifestDate',
                title: 'Manifest Date',
                dataAlign: 'center',
                formatter: formatDate,
                width: '125',
                filter: { type: 'TextFilter', delay: 1000 },
            },
            {
                dataField: 'supplierCode',
                title: 'Supplier Code',
                dataAlign: 'center',
                width: '125',
                filter: { type: 'TextFilter', delay: 500 },
            },
            {
                dataField: 'supplierName',
                title: 'Supplier Name',
                width: '250',
                filter: { type: 'TextFilter', delay: 500 },
            },
            {
                dataField: 'emcDock',
                title: 'Dock',
                dataAlign: 'center',
                width: '80',
                filter: { type: 'TextFilter', delay: 500 },
            },
        ];

        // Add order groups to manifest order group
        times(maxNumberOfOrderGroups, orderGroupIndex => {
            const manifestsPerOrderGroup = find(maxManifestsPerOrderGroup, {
                orderGroup: orderGroupIndex + 1,
            });
            const max = manifestsPerOrderGroup.maxManifests;
            columns.push({
                dataField: '',
                title: orderGroupIndex + 1,
                dataAlign: 'center',
                width: max === undefined || max === 0 || max === 1 ? '60' : (max * 30).toString(),
                formatter: this.manifestsFormatter(orderGroupIndex),
            });
        });

        return (
				<div>
            <BootstrapTable
                striped
                options={{
                    noDataText: isFetching ? (
                        <SmallLoader />
                    ) : (
                        'No data to display. Please refine your search.'
                    ),
                    sizePerPage: 15,
                    sizePerPageList: [15, 50, 100, 250, 500],
                    prePage: 'Prev',
                    nextPage: 'Next',
                    firstPage: 'First',
                    lastPage: 'Last',
                    paginationShowsTotal: renderPaginationShowsTotal,
                }}
                data={manifestOrderGroups}
                keyField="id"
                pagination
            >
                {columns.map((column, index) => (
                    <TableHeaderColumn
                        key={index}
                        dataField={column.dataField}
                        dataFormat={column.formatter}
                        hidden={column.hidden}
                        filter={column.filter}
                        dataAlign={column.dataAlign}
                        width={column.width}
                    >
                        {column.title}
                    </TableHeaderColumn>
                ))}
            </BootstrapTable>
			</div>
        );
    }
}

export default RFUTable;
